/**
 * @fileoverview GET handler for the "/engagement/campaigns/campaign_limits/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCampaignLimitsAppGroupId } from "./constants";
import type { EngagementCampaignLimitsResult } from "./types";

export const getEngagementCampaignLimits = reactQueryFetcherAdapter(
  engagementCampaignsCampaignLimitsAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementCampaignLimitsResult> => {
    return fetch(`/engagement/campaigns/campaign_limits/${appGroupId}`, "GET", {}, { signal });
  }
);
